import './AboutCertificates.scss';
import Subtitle from 'components/TextComps/Subtitle';
import { useTranslation } from 'react-i18next';

export const AboutCertificates = () => {
  const { t } = useTranslation();

  return (
    <div className='about-certificates'>
      <div className='about-certificates-section'>
        <h2>{t('AboutTrackmanCertificates', { ns: 'certificationsFAQ' })}</h2>
        <span>{t('TrackmanCertificationsHelpGolfProfessionals', { ns: 'certificationsFAQ' })}</span>
      </div>
      <div className='about-certificates-section'>
        <Subtitle>{t('LearnBuildAndGrow', { ns: 'certificationsFAQ' })}</Subtitle>
        <span>{t('TrackmanCertifiedProfessionalsAreRecognized', { ns: 'certificationsFAQ' })}</span>
      </div>
      <div className='about-certificates-section'>
        <Subtitle>{t('TrackmanCertificate', { ns: 'certificationsFAQ' })}</Subtitle>
        <span>{t('AfterCompletingACertificationCourse', { ns: 'certificationsFAQ' })}</span>
      </div>
    </div>
  );
};
